/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationStatisticsRequest {
    getFixupPrototypeFunction() { return UtilizationStatisticsRequest.fixupPrototype; }

    static newInstance(model: Partial<UtilizationStatisticsRequest>): UtilizationStatisticsRequest {
        let obj = Object.assign(new UtilizationStatisticsRequest(), model);
        UtilizationStatisticsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationStatisticsRequest>): UtilizationStatisticsRequest {
        if (!model) return null;
        return UtilizationStatisticsRequest.newInstance(<UtilizationStatisticsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationStatisticsRequest) {
        if (!obj) return;

        models.UtilizationStatisticsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationStatisticsRequest): boolean {
        Object.setPrototypeOf(obj, UtilizationStatisticsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of tenant ids for which data needs to be passed.
     */
    tenant_ids: Array<string>;

}
